import React, { createContext, useEffect, useRef, useState } from 'react'
import BackBar from '../home/BackBar'
import UnlockedProfileBox from './UnlockedProfileBox'
// import AddToList from '../Vaccancy/AddToList'
import { SELECT_CANDIDATE, UNLOCKED_PROFILESS } from '../../Service/service'
import { getData } from '../../Service/ApiMethod'
import UnlockedRoundProfileBox from './UnlockedRoundProfileBox'
import { useTranslation } from "react-i18next";
import Footer from '../../common/Footer'
import Header from '../../common/HeaderAfterLogin'
import Loader from '../login/Loader'
import { lang } from '../../lang'


const GetReflectOnRound = createContext()

const UnlockedProfile = () => {
  const [ln,setLn] = useState('en')
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [createListAll, setCreateListAll] = useState(false)
  const [AllUnlocked, setAllUnlocked] = useState(true)
  const [round, setRound] = useState(false)
  // const [filteredData, setFilteredData] = useState()
  const [firstRound, setFirstRound] = useState(false)

  const [secondRound, setSecondRound] = useState(false)
  const [selectedRound, setSelectedRound] = useState(false)
  const [rejectedRound, setRejectedRound] = useState(false)
  const [searchedCandidates, setSearchedCandidates] = useState()
  const [searchKeyword, setSearchKeyword] = useState()
  const [changeRound, setChangeRound] = useState(false)
  // const [seekID, setSeekID] = useState()
  const [search, setSearch] = useState(false)
  // const [candiadtesData, setCandiadtesData] = useState()
  const [Loaders,setLoader] = useState(false)
  // const [sdata, setSdata] = useState([]);
  const pageNo = useRef(1)
  const totalPage = useRef(1)
  // const updateVa = useRef([])
  const val = useRef('')
  const Type = useRef(0)
  const { t } = useTranslation()
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  const getSelectedCandidate = () => {
    getData(UNLOCKED_PROFILESS+ "?pgNo=" + pageNo.current + "&keyword=" + val.current + "&filter=" + Type.current) 
      .then((response) => response.json())
      .then((data) => {
        const response = data;
        console.log(response.data,"0000000000",UNLOCKED_PROFILESS+ "?pgNo=" + pageNo.current + "&keyword=" + val.current + "&filter=" + Type.current);
        console.log('vaccancies', data.data)
        setSelectedCandidates(response.data.unlocked_profile);
        totalPage.current = response.data.total_pages
        setLoader(false);
        // if (response.data.page_num == 1) {
        //   console.log("ss1")
        //   // let _sortedData = response.data.sort((a, b) => moment(b?.unlocked_on) - moment(a?.unlocked_on))
        //   setSelectedCandidates(response.data.unlocked_profile);
        //   updateVa.current = response.data.unlocked_profile
        //   // setunlockedProfileData(response.data);
        //   // newdata = response.data.unlocked_profile
        //   totalPage.current = response.data.total_pages
        //   setLoader(false);
        // } else if (pageNo.current < totalPage.current) {
        //   console.log("ss2")
        //   let valuu = selectedCandidates
        //   response.data.unlocked_profile.map((it) => {
        //     valuu.push(it)
        //   })
        //   setSelectedCandidates(valuu);
        //   // setMyVacancyData(valuu)
        //   updateVa.current = valuu
        //   console.log("okno1", valuu);
        //   setLoader(false);
        // }
        // else {
        //   // Alert.alert('Error', response.message);
        //   setLoader(false);
        // }


        // setSelectedCandidates(data.data);
        // setSdata(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };

  console.log('unlocked profiles Data in filter', selectedCandidates);


  const handleRoundData = (round_name) => {
    // const filterArray = selectedCandidates?.filter((item) => item?.round_status == round_name);
    // console.log('filterArray', filterArray)
    Type.current = round_name == "First Round" ? 2:round_name == "Second Round"? 3:round_name == "Rejected"?5:round_name == "Selected"?4:0
    console.log( Type.current,"ddddddddddddd",round_name);
    setTimeout(()=>{
      getSelectedCandidate()
      setAllUnlocked(false)
      setRound(true)
    },1000)
    
    // setFilteredData(filterArray);
    // if(filterArray?.length>0){
   
    // } else{ 
    //   alert('List is empty')
    // }
  }
  // console.log('FilteredData', filteredData)

  const getSearchKey = (keyword) => {
    setSearchKeyword(keyword)
  }

  console.log('setSearchKeyword', searchKeyword)

  const onSearch = (keyword) => {
    console.log(keyword,"sssssss");
    if(keyword != "" ){
      val.current = keyword
      pageNo.current = 1
      Type.current = 0
      getSelectedCandidate()
    }else{
      alert("please enter value")
      val.current = ""
      pageNo.current = 1
      Type.current = 0
      getSelectedCandidate()
    }
    // let temp = [...selectedCandidates];
    // if (keyword) {
    //   const newData = temp?.filter((item) => item?.candidate[0]?.first_name?.toLowerCase()?.includes(keyword?.toLowerCase()))



    //   // console.log('applied item---->', item);
    //   // const Name = item?.candidate[0]?.first_name?.toUpperCase();
    //   // const CompanyName = item.recruiter_name ? item.recruiter_name.toUpperCase(): ''.toUpperCase();
    //   // const JobTitle = item.vacancy.job_category_name ? item.vacancy.job_category_name.toUpperCase():''.toUpperCase();
    //   // const textData = searchKeyword.toUpperCase();
    //   // Name == textData

    //   // return ( Name.indexOf(textData) !== -1
    //   // ||
    //   // CompanyName.indexOf(textData) !== -1 ||
    //   // JobTitle.indexOf(textData) !== -1
    //   // )
    //   // console.log('name',  item?.candidate[0]?.first_name)
    //   //  return( item?.candidate[0]?.first_name == searchKeyword )

    //   // );
    //   console.log('newData', newData)
    //   setSearchedCandidates(newData)
    //   setRound(false)
    //   setAllUnlocked(false)
    //   setSearch(true)
    //   setFirstRound(false)
    //   setSelectedRound(false)
    //   setRejectedRound(false)
    //   setSecondRound(false)
    // }
    // else {
    //   // setSelectedCandidates(temp)
    //   alert('Please Enter a value')
    // }

  }

  console.log('After search', searchedCandidates)


  useEffect(() => {
    setLoaderstart(true)
    setTimeout(()=>{
      setLoaderstart(false)
    },2000)
    getSelectedCandidate();
    // onSearch()
  }, []);

  useEffect(() => {
    setLoaderstart(true)
    setTimeout(()=>{
      setLoaderstart(false)
    },2000)
    getSelectedCandidate();
    // onSearch()

  }, [changeRound]);

const [loaderStart, setLoaderstart] = useState(false)
  return ( 
    <>
      <GetReflectOnRound.Provider value={setChangeRound}>
        <Header />
        {
            loaderStart == true ? (
               <Loader />
            ) : null
         }
        <div className="2 wrapped-content-area" style={{  }}>
          <BackBar title={t("Unlocked Profile")} /> 
          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', position: 'unset', top: "20px" }}>
            <div
              className="search-container flex-center relative"
            >
              <input
                type="text"
                placeholder={t("Search by Candidate Name")}
                className="search-input form-control"
                onChange={(e) => {
                  getSearchKey(e.target.value)
                  if(e.target.value == ""){
                    val.current = ""
                    pageNo.current = 1
                    Type.current = 0
                    getSelectedCandidate()
                  }
                }}
                onKeyDown={e => e.key === 'Enter' ? onSearch(searchKeyword) : ''}
              />
              <span onClick={() => onSearch(searchKeyword)} style={{ cursor: 'pointer' }}>
                <img src="./images/search.png" alt="search" className="searchIcon"/>
              </span>
            </div>
          </div>
          <div className="container-fluid">
            {/* <div
            className="search-container flex-center relative"
            style={{ margin: "auto", marginTop: "10px" }}
          >
            <input
              type="text"
              placeholder="Search by Candidates/categories/Services"
              className="search-input"
            />
            <img src="./images/search.png" alt="search" />
          </div> */}

            {/* <hr className="mb-0 mt-1" /> */}

            <div className="hashtags-keys">
              <p className="filters">{t('Filters')}:- </p>
              <button className={AllUnlocked ? "active-tag " : "deactive-tags"} onClick={() => {
                setAllUnlocked(true)
                setCreateListAll(false)
                setRound(false)
                setFirstRound(false)
                setSelectedRound(false)
                setLoaderstart(true)
                setTimeout(()=>{
                  setLoaderstart(false)
                },2000)
                setRejectedRound(false)
                setSecondRound(false)
                // getSelectedCandidate()
                setSearch(true)
                handleRoundData('All')
               
                // setSearchedCandidates('')
                // setSecondRound(false)
              }}>{t('All')}</button>
              {/* <button className="deactive-tags" style={{ fontSize: '12px' }}>
              Unread
            </button> */}
              <button className={firstRound ? "active-tag " : "deactive-tags"} style={{ fontSize: '12px' }} onClick={() => {
                handleRoundData('First Round')
                setFirstRound(true)
                setSelectedRound(false)
                setRejectedRound(false)
                setLoaderstart(true)
                setTimeout(()=>{
                  setLoaderstart(false)
                },2000)
                setSecondRound(false)
                setSearch(false)
                setAllUnlocked(false)
              }}
              >
                {t('First Round')}
              </button>
              <button className={secondRound ? "active-tag " : "deactive-tags"} style={{ fontSize: '12px' }}
                onClick={() => {

                  handleRoundData('Second Round')
                  setFirstRound(false)
                  setSelectedRound(false)
                  setRejectedRound(false)
                  setLoaderstart(true)
                  setTimeout(()=>{
                    setLoaderstart(false)
                  },2000)
                  setSecondRound(true)
                  setAllUnlocked(false)
                  setSearch(false)
                }}
              >
                {t('Second Round')}
              </button>
              <button
                className={rejectedRound ? "active-tag " : "deactive-tags"}
                style={{ fontSize: '12px' }}
                onClick={() => {

                  handleRoundData('Rejected')
                  setFirstRound(false)
                  setSelectedRound(false)
                  setLoaderstart(true)
                  setTimeout(()=>{
                    setLoaderstart(false)
                  },2000)
                  setRejectedRound(true)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)

                }}
              >
                {t('Rejected')}
              </button>
              <button className={selectedRound ? "active-tag " : "deactive-tags"} style={{ fontSize: '12px' }}
                onClick={() => {

                  handleRoundData('Selected')
                  setFirstRound(false)
                  setSelectedRound(true)
                  setLoaderstart(true)
                  setTimeout(()=>{
                    setLoaderstart(false)
                  },2000)
                  setRejectedRound(false)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)

                }}
              >
                {t('Selected')}
              </button>
              {/* <button className="deactive-tags" style={{ fontSize: '12px' }}>
              Shortlisted
            </button>
            <button className="deactive-tags" style={{ fontSize: '12px' }}>
              Freshers
            </button> */}
            </div>


            {AllUnlocked &&
              <div className="mt-3">
                <div className="row align-items-center justify-content-center">
                  <UnlockedProfileBox
                    candiadtes={selectedCandidates}
                    addList={() => {
                      setCreateListAll(!createListAll)
                    }}
                  />
                  {/* {createListAll ? (
               <AddToList
                 closePopup={() => {
                   setCreateListAll(!createListAll)
                 }}
                 seekerID={seekID}
               />
             ) : null} */}
                </div>
              </div>
            }

            {search && <UnlockedRoundProfileBox filteredUsersData={searchedCandidates} />
            }

            {round &&
              <UnlockedRoundProfileBox filteredUsersData={selectedCandidates} />
            }

          </div>
          <div style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                marginBottom: 10
              }}>
                <div>
                  <p style={{ marginBottom: 0, paddingRight: 5, cursor: "pointer" }} onClick={()=>{
                    if(pageNo.current > 1){
                      pageNo.current = pageNo.current-1
                      console.log("yo");
                      getSelectedCandidate()
                    }else{
                      console.log("no more data found");
                    }
                  }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["previous"]:""}</p> 
                </div>
                <input placeholder='Pg. no.' type="text" 
                disabled={true}
                style={{
                  textAlign: "center",
                  width: 60,
                  padding: 10,
                  borderColor: "#f2edf3",
                  backgroundColor: "#f2edf3",
                  borderRadius: 10,
                  borderWidth: 0
                }} value={pageNo.current+"/"+totalPage.current}  />
                <div>
                  <p style={{ marginBottom: 0, paddingLeft: 5, cursor: "pointer" }} onClick={()=>{
                    if(pageNo.current < totalPage.current){
                      pageNo.current = pageNo.current+1
                      console.log("yono");
                      getSelectedCandidate()
                    }else{
                      console.log("no more data found");
                    }
                  }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Next"]:""}</p>
                </div>
              </div>
        </div>
        <Footer />
      </GetReflectOnRound.Provider>
    </>
  )
}

export default UnlockedProfile

export { GetReflectOnRound }
